import { read } from 'react-read';
import { WEBGATE_DOMAIN, webgateFetchJson } from '../../lib/api';
/** @happy-path data-loading/00-import-dataloader */
import { createBatchLoader } from '../../dataloader';
import { ArtistsResponse } from './types';
import { formatArtist } from './formatArtist';

/** @happy-path data-loading/01-create-loader The load function can be inline
 * for batch or single loaders. Remember: batch responses must be consistently
 * ordered for dataloader to function properly! */
const artistLoader = createBatchLoader(async (artistUris: string[]) => {
  const { artists } = (await webgateFetchJson(
    `${WEBGATE_DOMAIN}/creator-search-service/v0/artists/decorate`,
    {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ artistUris }),
    },
  )) as ArtistsResponse;

  const artistMap = new Map(artists.map(artist => [artist.uri, artist]));

  // the backend doesn't guarantee order
  return artistUris.map(uri => {
    const artist = artistMap.get(uri);
    return artist ? formatArtist(artist) : null;
  });
});

/** @happy-path data-loading/02-expose-a-nice-interface Not all code needs to
 * directly use the loader. It's often better to wrap it into a hook-like
 * interface for ease of use and mocking. */
export function useArtist(artistId: string) {
  return read(artistLoader.load(`spotify:artist:${artistId}`));
}
